import { logError } from '~/utils/log-error'
import type { PDFViewerType } from '~/models/pdf-viewer.type'
import { encodeObject } from '~/utils/functions'

export function useOpenPDFViewer() {
  const router = useRouter()

  function openPDFViewer(
    documentId: string,
    title: string,
    url?: string,
    type?: PDFViewerType,
    subscriptionRequired?: string,
  ) {
    try {
      const data: Record<
        string,
        string | number | boolean | unknown | undefined
      > = {
        id: documentId,
        url,
        type,
        title,
        subscription_required: subscriptionRequired,
      }

      const id = encodeObject(data)
      router.push(`/viewer/pdf/${id}`)
    } catch (error) {
      logError(error)
    }
  }

  return { openPDFViewer }
}
